import React from 'react';
import { CargoTempLogStatusEnum } from '../../../enums/cargoTempLogEnum';
import CargoTempLogStatusIcon from '../../ui/status-icon/CargoTempLogStatusIcon';
import { Header, HeaderItem, HeaderSection } from './CargoTempLogReporting.style';

type CargoLogHeaderProps = {
    hasMissingConfigs: boolean;
};

const CargoLogHeader: React.FC<CargoLogHeaderProps> = ({ hasMissingConfigs }) => {
    if (!hasMissingConfigs) {
        return null;
    }

    return (
        <Header>
            <HeaderSection>
                <HeaderItem>{CargoTempLogStatusIcon(CargoTempLogStatusEnum.configMissing)}</HeaderItem>
                <HeaderItem>
                    <h3>You have new cargoes to configure!</h3>
                    <h4>You have 2 options:</h4>
                    <h5>1. Configure each cargo individually</h5>
                    <h5>
                        2. Configure all new cargoes by expanding <span className="highlight">Set one configuration for all new cargoes</span>
                    </h5>
                </HeaderItem>
            </HeaderSection>
        </Header>
    );
};

export default CargoLogHeader;
